import { Box, useTheme } from "@mui/material";
import { tokens } from "../theme";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ArcList = ({ dataValues = []}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
  return (
    <Box m="20px" height="100%" width="100%" mt='106px'>
      {
        dataValues.map(row => {
          return (
            <Accordion defaultExpanded key={row['dis']}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography color={colors.greenAccent[500]} variant="h5">
                  {row["dis"]}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  {row["desc"]}
                </Typography>
              </AccordionDetails>
            </Accordion>
          )
        })
      }
    </Box>
  );
};

export default ArcList;
